/* eslint-disable */
import { boot } from 'quasar/wrappers';
import { Cookies } from 'quasar';
import axios from 'axios';

let $axios;

export const initCookies = (ssrContext) => (process.env.SERVER
  ? Cookies.parseSSR(ssrContext)
  : Cookies);

export const getCookieToken = (key, ssrContext = {}) => {
  const cookies = initCookies(ssrContext);
  return cookies.get(key);
};

const replaceEmptyStrings = (data, skip) => {
  if (data instanceof FormData || skip) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => replaceEmptyStrings(item));
  } else if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => {
        if (typeof value === 'string' && value.trim() === '') {
          return [key, null];
        } else {
          return [key, replaceEmptyStrings(value)];
        }
      }),
    );
  } else {
    return data;
  }
};

export default boot(({ app, ssrContext }) => {
  $axios = axios.create({ baseURL: `${process.env.API_HOST}/api` });

  $axios.interceptors.request.use((config) => {
    const token = getCookieToken('accessToken', ssrContext);

    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  });

  $axios.interceptors.request.use((config) => {
    config.data = replaceEmptyStrings(config.data, config.skipReplaceInterceptor);
    return config;
  });

  app.provide('axios', $axios);
});

export { $axios };
